import React from "react";
import { resolveStatusBadgePresentationExternal } from "libs/context/statusMetadataBridge";

/**
 * Imperative status pill for table body helpers (call executive, etc.).
 */
export const renderStatusMetadataPill = (
  value,
  { accessor, pageName = "", className = "px-2 py-1 fw-semibold common-table-status-badge", fallbackClassName = "" } = {}
) => {
  if (value === null || value === undefined || String(value).trim() === "") {
    return <span className="text-muted">—</span>;
  }

  const presentation = resolveStatusBadgePresentationExternal({
    accessor,
    pageName,
    value,
    fallbackClassName,
  });

  const displayLabel = presentation?.displayLabel ?? String(value).trim();

  if (presentation?.inlineStyle) {
    return (
      <span className={className} style={presentation.inlineStyle}>
        {displayLabel}
      </span>
    );
  }

  const resolvedClassName = [
    className,
    presentation?.fallbackClassName || fallbackClassName,
  ]
    .filter(Boolean)
    .join(" ");

  return <span className={resolvedClassName}>{displayLabel}</span>;
};
